module.exports = __webpack_public_path__ + "static/media/alliancepartner.9eb20966.svg";